/// <amd-module name="TFS/Views/ProjectOverviewPage/Shared/ProjectBasicInfoStore" />
import { Store } from "VSS/Reflux/Store";

import { StoreLoadingState, UpdatingState } from "TFS/Views/ProjectOverviewPage/Shared/Contracts";
import { ProjectBasicData } from "TFS/Views/ProjectOverviewPage/Shared/Models";

export interface ProjectBasicInfoState {
    loadingState: StoreLoadingState;
    projectBasicInfo: ProjectBasicData | undefined;
    descriptionUpdateState: UpdatingState;
    descriptionError: string | undefined;
}

export enum ProjectBasicInfoStoreEvents {
    DescriptionUpdateEvent = "DescriptionUpdateEvent"
}

export class ProjectBasicInfoStore extends Store {
    private _state: ProjectBasicInfoState = {
        loadingState: StoreLoadingState.Loading,
        projectBasicInfo: undefined,
        descriptionUpdateState: UpdatingState.NotUpdating,
        descriptionError: undefined
    };

    public getState(): ProjectBasicInfoState {
        return this._state;
    }

    public loadProjectInfo = (projectBasicInfo: ProjectBasicData): void => {
        this._state.projectBasicInfo = projectBasicInfo;
        this._state.loadingState = StoreLoadingState.Loaded;
        this.emitChanged();
    };

    public loadProjectInfoFailed = (): void => {
        this._state.loadingState = StoreLoadingState.LoadFailed;
        this.emitChanged();
    };

    public projectDescriptionUpdated = (newDescription: string): void => {
        if (this._state.projectBasicInfo && this._state.projectBasicInfo.description != newDescription) {
            this._state.projectBasicInfo.description = newDescription;
            this._state.descriptionUpdateState = UpdatingState.Succeeded;
            this.emit(ProjectBasicInfoStoreEvents.DescriptionUpdateEvent, this);
        }
    };

    public projectDescriptionUpdateFailed = (message: string | undefined): void => {
        this._state.descriptionUpdateState = UpdatingState.Failed;
        this._state.descriptionError = message;
        this.emit(ProjectBasicInfoStoreEvents.DescriptionUpdateEvent, this);
    };

    public projectDescriptionUpdateStarted = (): void => {
        this._state.descriptionUpdateState = UpdatingState.InProgress;
        this.emit(ProjectBasicInfoStoreEvents.DescriptionUpdateEvent, this);
    };

    public projectDescriptionNotUpdating = (): void => {
        this._state.descriptionError = undefined;
        this._state.descriptionUpdateState = UpdatingState.NotUpdating;
        this.emit(ProjectBasicInfoStoreEvents.DescriptionUpdateEvent, this);
    };
}
